const costMappings = JSON.parse(document.getElementById('cost-mappings').getAttribute('data_value'));;

export const countFor = (state, type) => {
    return state.samples.filter((s)=>{return s.checked[type] == true}).length
}

const getDepletionQuantityCost = (state, sample, type)=>{
    const capacity_quantity = (state.brewery.capacities[type] || {}).quantity || 0
    return capacity_quantity > 0 ? 0 : cost(sample, type)
}

const cost = (sample, inputName) =>{
    return sample.checked[inputName] ? costMappings[inputName] : null;
};

const getTotalCost = (state, sample, index) => {
    let total = 0;
    for(let property in costMappings){
       total += getDepletionQuantityCost(state, sample, property)
    }

    return total
};
const getCosts = (state, sample)=>{
    let costs = {};
    for(let property in costMappings){
        costs[property] = getDepletionQuantityCost(state, sample, property)
    }
    return costs;
}
export const process = (state, samples) => {
    const mapped_samples = samples.map((sample, index)=>{

        return {
            ...sample,
            index: index,
            cost: {
                ...sample.cost,
                ...getCosts(state, sample)
            }
        }
    })

    return mapped_samples.map((sample, index)=>{
        return {
            ...sample,
            totalCost: getTotalCost(state, sample, index)
        }
    })

};

export const checkInput = (state, action) => {

     const new_samples = state.samples.map((sample, index)=>{

        if(index == action.index){
            return {
                ...sample,
                checked: {
                    ...sample.checked,
                    [action.inputName]: action.checked
                }
            }
        } else{
            return sample;
        }

    });

    return process({...state, samples: new_samples}, new_samples)
}

export const changeSample = (samples, index, sample)=>{
    return samples.map((s, i)=>{
        return index == i ? sample : s;
    })
}
const uncheckAllChemistry = (sample)=>{
    let newSample = { ...sample };
    for(let property in newSample.cost) {
        if (property.startsWith('chemistry__')) {
            newSample = {
                ...newSample,
                cost: {
                    ...newSample.cost,
                    [property]: 0
                },
                checked: {
                    ...newSample.checked,
                    [property]: 0
                }
            }
        }
    }
    return newSample;
}
export const uncheckChemistryAccordion = (state, samples, index) => {
        return samples.map((s, i)=>{
                if(index == i) {
                    let sample = uncheckAllChemistry(s)
                    return {
                        ...sample,
                        totalCost: getTotalCost(state, sample, index)
                    }
                } else {
                    return s;
                }
        })
}


